import React, { useState, useEffect } from "react";

import { galleryData, galleryVideos } from "./galleryData";
import { Helmet } from "react-helmet-async";

export default function Gallery() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = () =>
    setCurrentIndex((prev) => (prev + 1) % galleryData.length);

  const prevImage = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? galleryData.length - 1 : prev - 1
    );
 

  return (
    <div>
           <Helmet>
  <title>Clinic Gallery & Videos | BrightLife Physio Point</title>
  <meta
    name="description"
    content="View photos and videos of treatments, rehabilitation sessions and patient recovery at BrightLife Physio Point."
  />
</Helmet>
       <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Gallery
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Gallery</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
          <div className="page-gallery py-5">
        <div className="container">
              <div className="section-title">
            <h2 className="text-anime-style-2">
              <span>Our Satisfied</span> Clients
            </h2>
          </div>
            <div className="gallery-grid">
  {galleryData.map((item, index) => (
    <div className="gallery-item" key={item.id}>
      
      {/* IMAGE */}
      {item.type === "image" && (
        <img
          src={item.src}
          alt={item.alt}
          draggable={false}
          onClick={() => openLightbox(index)}
        />
      )}




    </div>
  ))}
</div>
      <div className="section-title">
            <h2 className="text-anime-style-2 mt-5">
              <span>Videos</span> From Our Clinic
            </h2>
          </div>
         <div className="gallery-grid">
  {galleryVideos.map((item, index) => (
    <div className="gallery-item" key={item.id}>
      



      

      {/* VIDEO */}
     {item.type === "video" && (
        <div className="video-embed">
          <iframe
            src={`https://www.youtube.com/embed/${item.youtubeId}?rel=0&modestbranding=1`}
            title={item.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}

    </div>
  ))}
</div>


    {/* Lightbox */}
    {lightboxOpen && (
  <div className="lightbox" onClick={() => setLightboxOpen(false)}>
    <div
      className="lightbox-content"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close */}
      <button className="close" onClick={() => setLightboxOpen(false)}>
        ×
      </button>

      {/* Prev */}
      <button className="nav prev" onClick={() =>
        setCurrentIndex(
          currentIndex === 0 ? galleryData.length - 1 : currentIndex - 1
        )
      }>
        ‹
      </button>

      {/* Next */}
      <button className="nav next" onClick={() =>
        setCurrentIndex((currentIndex + 1) % galleryData.length)
      }>
        ›
      </button>

      {/* CONTENT SWITCH */}
      {galleryData[currentIndex].type === "image" && (
        <div className="watermark-wrapper">
          <img
            src={galleryData[currentIndex].src}
            alt=""
            draggable={false}
          />
        </div>
      )}

      {galleryData[currentIndex].type === "video" && (
        <div className="video-frame">
          <iframe
            src={`https://www.youtube.com/embed/${galleryData[currentIndex].youtubeId}?autoplay=1&rel=0`}
            title="Video"
            frameBorder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
    </div>
  </div>
)}

          </div>
        </div>
    </div>
  );
}